/* eslint-disable no-restricted-properties */
import { UnsignedByteType } from "three";
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader";
import * as THREE from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";

import { ASSET_EVENTS, ASSET_TYPES } from "../constants";
import Event from "./Event";

const mod = () => {
  const dracoLoader = new DRACOLoader();
  dracoLoader.setDecoderPath("./draco/gltf/");
  dracoLoader.preload();
  const gltfLoader = new GLTFLoader();
  gltfLoader.setDRACOLoader(dracoLoader);

  const rgbeLoader = new RGBELoader();
  rgbeLoader.setDataType(UnsignedByteType);
  const textureLoader = new THREE.TextureLoader();

  const cubeTextureLoader = new THREE.CubeTextureLoader();
  // modelLoad time
  let modelSize = null;
  // map id -> assetObject
  const assetsMap = {};
  // map of id => {type, url}
  const assetMetaMap = {};

  const loadedEvent = (assetMeta) =>
    Event.sendSMEvent(ASSET_EVENTS.ASSET_LOADED, assetMeta);

  const loadGltf = async (id, assetMeta) => {
    console.log("gltf to be loaded", assetMeta, id);
    if (assetsMap[id]) {
      console.log("model already loaded", assetsMap[id]);
      return;
    }

    await new Promise((resolve) => {
      gltfLoader.load(
        assetMeta.url,
        (gltfObject) => {
          console.log("gltf loaded successfully", gltfObject.scene);
          const model = gltfObject.scene;
          model.traverse((object) => {
            if (object.isMesh) {
              object.castShadow = true;
              // object.receiveShadow = true;
              if (object.material.map) object.material.map.anisotropy = 16;
            }
          });
          assetsMap[id] = gltfObject;
          loadedEvent(assetMeta);
          resolve();
        },
        (data) => {
          modelSize = (data.total / Math.pow(10, 6)).toFixed(2);
        },
        (event) => {
          console.log("gltf loaded successfully gltf error events", event);
          resolve();
        }
      );
    });
  };

  const loadImage = async (id, assetMeta) => {
    if (assetsMap[id]) {
      console.log("image already loaded", assetsMap[id]);
      return;
    }
    await new Promise((resolve) => {
      const image = new Image();
      image.src = assetMeta.url;
      image.onload = () => {
        assetsMap[id] = image;
        loadedEvent(assetMeta);
        resolve();
      };
    });
  };

  const loadTexture = async (id, assetMeta) => {
    if (assetsMap[id]) {
      console.log("texture already loaded", assetsMap[id]);
      return;
    }
    await new Promise((resolve) => {
      textureLoader.load(assetMeta.url, (texture) => {
        texture.encoding = THREE.sRGBEncoding;
        texture.wrapS = THREE.RepeatWrapping;
        texture.wrapT = THREE.RepeatWrapping;
        assetsMap[id] = texture;
        loadedEvent(assetMeta);
        resolve();
      });
    });
  };
  const loadCubeTexture = async (id, assetMeta) => {
    console.log("loadcubetexture", assetMeta);
    if (assetsMap[id]) {
      console.log("texture already loaded", assetsMap[id]);
      return;
    }

    await new Promise((resolve) => {
      cubeTextureLoader.load(
        assetMeta.urls,
        (texture) => {
          console.log("cube texture loader", texture);
          texture.encoding = THREE.sRGBEncoding;
          texture.wrapS = THREE.RepeatWrapping;
          texture.wrapT = THREE.RepeatWrapping;
          assetsMap[id] = texture;
          loadedEvent(assetMeta);
          resolve();
        },
        () => {},
        (err) => {
          console.log("cube texture loader error", err);
          resolve();
        }
      );
    });
  };

  const loadHDRI = async (id, assetMeta) => {
    if (assetsMap[id]) {
      console.log("hdri already loaded", assetsMap[id]);
      return;
    }
    await new Promise((resolve) => {
      rgbeLoader.load(assetMeta.url, (texture) => {
        assetsMap[id] = texture;
        loadedEvent(assetMeta);
        resolve();
      });
    });
  };
  // expecting object of id: {type, url}
  const loadAssets = async (assetMetaObject, idList) => {
    console.log("loadassets", assetMetaObject, idList);
    const promises = [];
    idList.forEach((id) => {
      const assetMeta = assetMetaObject[id];
      assetMetaMap[id] = assetMeta;
      switch (assetMeta.type) {
        case ASSET_TYPES.GLTF: {
          promises.push(loadGltf(id, assetMeta));
          break;
        }
        case ASSET_TYPES.CUBE_MAP: {
          promises.push(loadCubeTexture(id, assetMeta));
          break;
        }
        case ASSET_TYPES.IMAGE: {
          promises.push(loadImage(id, assetMeta));
          break;
        }
        case ASSET_TYPES.TEXTURE: {
          promises.push(loadTexture(id, assetMeta));
          break;
        }
        case ASSET_TYPES.HDRI: {
          promises.push(loadHDRI(id, assetMeta));
          break;
        }
        default:
          console.log("invalid type loaded", assetMeta);
      }
    });
    console.log("load assetsXXX", promises, assetMetaObject, idList);
    await Promise.all(promises);
  };
  const loadAllAssets = async (assetMetaObject) => {
    console.log("loadall assets", assetMetaObject);
    return loadAssets(assetMetaObject, Object.keys(assetMetaObject));
  };
  const isLoaded = (idList) => {
    console.log("isloaded", idList);
    return idList.every((id) => {
      const flag = id in assetMetaMap && assetsMap[id];
      if (!flag) console.log("isloaded not loaded for", id, assetMetaMap[id]);
      return flag;
    });
  };
  return {
    isAssetObjectsLoaded: (assetObject) => {
      return isLoaded(Object.keys(assetObject));
    },
    isLoaded,
    getAsset: (id) => {
      return assetsMap[id];
    },
    getAssets: (idList) => {
      return idList.map((id) => assetsMap[id]);
    },
    loadAllAssets,
    loadAssets,
    getURLFromAssetId: (id) => {
      return assetMetaMap[id].url;
    },
    getModelSize: () => {
      return modelSize;
    },
  };
};

const AssetLoader = mod();
export default AssetLoader;
